import { render, staticRenderFns } from "./PersonalTouch.vue?vue&type=template&id=68d08294&scoped=true"
import script from "./PersonalTouch.vue?vue&type=script&lang=js"
export * from "./PersonalTouch.vue?vue&type=script&lang=js"
import style0 from "./PersonalTouch.vue?vue&type=style&index=0&id=68d08294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d08294",
  null
  
)

export default component.exports